import React from 'react';
import { Link } from 'react-router-dom';
import { useCompany } from '../context/CompanyContext';
import BrandLogoMark from './BrandLogoMark';

/**
 * Marca compacta: monograma + nombre (o logo de empresa si está configurado).
 */
export default function BrandMark({
  to = '/',
  className = 'np-logo',
  markClassName = 'np-logo-mark-svg',
  nameClassName = 'np-logo-name',
  showName = true,
  ariaLabel,
}) {
  const { company, companyName, logoUrl, loading } = useCompany();
  const displayName = companyName || null;
  const logoHeight = Math.min(Number(company?.logo_height) || 28, 40);
  const logoWidth = Math.min(Number(company?.logo_width) || 120, 160);

  const inner = (
    <>
      {logoUrl ? (
        <img
          src={logoUrl}
          alt=""
          className="np-brand-logo-img"
          style={{ height: logoHeight, maxWidth: logoWidth, objectFit: 'contain' }}
          aria-hidden
        />
      ) : (
        <BrandLogoMark className={markClassName} />
      )}
      {showName && displayName && (
        <span className={nameClassName}>{displayName}</span>
      )}
      {showName && !displayName && loading && (
        <span className={`${nameClassName} np-logo-name--loading`} aria-hidden />
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={className} aria-label={ariaLabel || displayName || 'Inicio'}>
        {inner}
      </Link>
    );
  }

  return (
    <span className={className} aria-label={ariaLabel || displayName || 'Marca'}>
      {inner}
    </span>
  );
}
